"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    id: "g214",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      id: "g239",
      transform: "matrix(0.68585261,0,0,0.68585261,0.24864128,0.20362452)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polyline", {
        points: "15 14 20 9 15 4",
        id: "polyline182"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M 4,20 V 13 A 4,4 0 0 1 8,9 h 12",
        id: "path184"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      id: "\u2731-/-Icon-/-Datatype-/-String",
      transform: "matrix(0.63616913,0,0,0.63616913,-0.96611732,11.160764)",
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        id: "Group-3",
        transform: "translate(3.5,4)",
        stroke: "currentColor",
        strokeWidth: "2",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          id: "Group-2",
          transform: "translate(7)",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M 5.0909091,1.1428571 V 14.857143",
            id: "Path"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M 10.285714,0.57142857 H 0",
            id: "Path-Copy"
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          id: "Group",
          transform: "translate(0,6.285714)",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M 2.8051948,1.7142857 V 8.5714286",
            id: "path39"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M 5.7142857,0.57142857 H 0",
            id: "path41"
          })]
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "matrix(0.54787717,0,0,0.54787717,13.19375,-0.16997133)",
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: "1",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      id: "\u2731-/-Icon-/-Datatype-/-Financial",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        stroke: "currentColor",
        strokeWidth: "2",
        id: "dollar-sign",
        transform: "translate(7,2)",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M 5.5,0 V 20",
          id: "Path-0"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M 10,3 H 3.1818182 C 1.4245485,3 0,4.5670034 0,6.5 0,8.4329966 1.4245485,10 3.1818182,10 h 4.5454545 c 1.7572697,0 3.1818183,1.567003 3.1818183,3.5 0,1.932997 -1.4245486,3.5 -3.1818183,3.5 H 0",
          id: "path134"
        })]
      })
    })]
  })
}));